import PasswordManager from './components/PasswordManager'
import './App.css'

const App = () => <PasswordManager />

export default App
